/* eslint-disable jira/filename-case */
import type { ThemeColorModes } from '@atlaskit/tokens/theme-config';

export const THEME_PREFERENCE_KEY = 'jira.user.theme.preference' as const;

export const THEME_PREFERENCES_ANALYTICS_SUBJECT = 'themePreference';
export const THEME_PREFERENCES_ANALYTICS_ACTION = 'changed';

export const themeColorModes: ThemeColorModes[] = ['light', 'dark', 'auto'] as const;
export const DEFAULT_COLOR_MODE: ThemeColorModes = 'auto';
